import { observable, action } from 'mobx';
import { QRCodeModalData } from './types';

export const qrCodeModalState = observable<{
  isOpen: boolean;
  data: QRCodeModalData | null;
}>({
  isOpen: false,
  data: null,
});

export const openQRCodeModal = action((data: QRCodeModalData = {}) => {
  qrCodeModalState.data = data;
  qrCodeModalState.isOpen = true;
});

export const closeQRCodeModal = action(() => {
  qrCodeModalState.isOpen = false;
  qrCodeModalState.data = null;
});
